const StatesList = [
  {
    label: 'South Carolina',
    value: 'southCarolina'
  }
];

export default { StatesList };
